import IndividualNavbar from "../IndividualNavbar/IndividualNavbar";
import IndividualProjectContent from "../IndividualProjectContent/IndividualProjectContent";

export default function IndividualProjectPage() {
    return (
        <main>
            <section id="individualNavbar">
                <IndividualNavbar />
            </section>

            <section id="individualProjectContent">
                <IndividualProjectContent/>
            </section>
        </main>
    );
}